export default function controller() {
    const $ctrl = this;

    $ctrl.isTileSelected = () => {
        return $ctrl.lossCauseTileType === $ctrl.model.value.code;
    };
}